/**
 * Message à afficher quand l'envoi d'une preuve d'acompte (fichier
 * « proof-deposit ») est refusé par l'API. Les codes sont ceux de
 * DepositProofUploadValidator côté backend, comparés mot pour mot ; les
 * limites affichées (pages, taille) doivent rester alignées sur ses
 * constantes MAX_PAGES et MAX_BYTES.
 */
export const PROOF_DEPOSIT_MAX_PAGES = 5;
export const PROOF_DEPOSIT_MAX_MB = 3;

export const PROOF_DEPOSIT_UPLOAD_MESSAGES: Record<string, string> = {
    proof_deposit_too_many_pages: `La preuve d'acompte ne doit pas dépasser ${PROOF_DEPOSIT_MAX_PAGES} pages. Envoyez uniquement la ou les pages qui montrent le versement.`,
    proof_deposit_too_large: `La preuve d'acompte ne doit pas dépasser ${PROOF_DEPOSIT_MAX_MB} Mo. Compressez le fichier ou envoyez uniquement la page utile.`,
    proof_deposit_unreadable: "Ce fichier n'est pas un PDF lisible. Enregistrez-le à nouveau ou envoyez une image (PNG ou JPEG).",
    "The file size must not exceed 5 MB.": `La preuve d'acompte ne doit pas dépasser ${PROOF_DEPOSIT_MAX_MB} Mo. Compressez le fichier ou envoyez uniquement la page utile.`,
    "The file size must not exceed 5 mbits.": `La preuve d'acompte ne doit pas dépasser ${PROOF_DEPOSIT_MAX_MB} Mo. Compressez le fichier ou envoyez uniquement la page utile.`,
};

export const PROOF_DEPOSIT_UPLOAD_GENERIC_MESSAGE = "Le fichier n'a pas pu être envoyé. Réessayez ou choisissez un autre fichier.";

export const describeProofDepositUploadError = (error: any, fallback: string = PROOF_DEPOSIT_UPLOAD_GENERIC_MESSAGE): string => {
    const description: string | undefined = error?._description ?? error?.description;
    return (description && PROOF_DEPOSIT_UPLOAD_MESSAGES[description]) || fallback;
};

export default describeProofDepositUploadError;
